import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=2c6fd7d5&"
import script from "./Solution.vue?vue&type=script&lang=ts&"
export * from "./Solution.vue?vue&type=script&lang=ts&"
import style0 from "./Solution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports